<script setup>
import { defineProps, onMounted, ref } from 'vue';

const props = defineProps({
  data: Object,
  backToBlockSelector: String,
});

const HEADER_OFFSET = 60;

const animatedScrollTo = (selector, animationTime, topOffset) => {
  const selectedElem = document.querySelector(selector);

  if (selectedElem) {
    if (!animationTime && animationTime !== 0) {
      animationTime = 200;
    }
    topOffset = topOffset || 0;

    // Use native JavaScript to scroll smoothly
    const scrollTop = selectedElem.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET + topOffset;
    window.scrollTo({
      top: scrollTop,
      behavior: 'smooth',
    });
  } else {
    // Handle the case where the element is not found
    console.error(`Element with selector '${selector}' not found.`);
  }
};


const isScrolledOut = (elem) => {
  const distance = elem.getBoundingClientRect();
  return distance.bottom > 0;
};

onMounted(() => {
  window.addEventListener('scroll', () => {
    const wrapper = document.querySelector(props.backToBlockSelector);
    const container = document.querySelector('.floating-wrapper .floating-container');
    if (isScrolledOut(wrapper)) {
      container.classList.remove('footer-floating-wrapper');
    } else {
      container.classList.add('footer-floating-wrapper');
    }
  });

  document.querySelectorAll('.back-to-floating-block').forEach((button) => {
    button.addEventListener('click', () => {
      animatedScrollTo(props.backToBlockSelector, 1500, 0);
    });
  });
});
</script>

<template>
  <div class="block floating-wrapper">
    <div class="floating-container">
      <div class="sticky-footer container">
        <div class="row row-flex">
          <div class="col-6 d-flex align-items-center justify-content-start"></div>
          <div class="col-6 align-content-center text-end">
            <a class="back-to-floating-block www btn btn-id-primary mt-4 mb-4 d-none d-lg-block">
                {{ data && data.footerButtonText ? data.footerButtonText : '' }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.block.floating-wrapper {
    position: sticky;
    top: 110px;
    margin: 0 auto;
    z-index: 10;

  .floating-container {
    &:not(.footer-floating-wrapper) {
      .sticky-footer {
          display: none;
      }
    }
    &.footer-floating-wrapper {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        top: auto;
        z-index: 10;
        background: $white;
        padding: 15px 0;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
        -webkit-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
        -moz-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
    }
  }
}
</style>
